import { GENERIC_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsGenericEvents';

import { Content } from 'LegacySBCRA/Content/Content';

import { ExpandableSection } from '../../fastlane/expandableSection/ExpandableSection';
import { CAR_CHECK_SNOWPLOW } from '../CarCheckerHero/SubComponents/CarCheckerForm/CarCheckerForm.helpers';

import questions from './CarCheckFAQ.json';

import styles from './CarCheckFAQ.module.scss';

export const CarCheckFAQ = () => (
  <Content className={styles.container}>
    <ExpandableSection
      analyticsEvents={{
        onButtonClick: ({ isOpen, label }) => {
          if (!isOpen) {
            return;
          }

          GENERIC_ANALYTICS_EVENTS.POPUP_LOAD_EVENT({
            category: CAR_CHECK_SNOWPLOW.category,
            label,
            name: 'CarCheckFAQ_ButtonClick',
          });
        },
      }}
      content={questions}
      title='Common questions about car checks'
    />
  </Content>
);
